import React, { Fragment, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import TextInputField from "../../editable/EditableField/fields/TextInputField";
import { api, Booking, IBookingCreate, IPackageList, Package } from "../../../logic/api";
import { PagedDataView } from "../../lists/PagedDataView/PagedDataView";
import PackageListItemSelector from "../../lists/listItems/PackageListItemSelector/PackageListItemSelector";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PackagePicker: React.FunctionComponent<{
  title?: string | null;
  currentPackageCode?: string | null;
  show: boolean;
  onClose: (pkg: Package | null) => void;
  booking?: Booking | IBookingCreate;
}> = (props) => {

  const [packageListFetchParams, setPackageListFetchParams] = useState<IPackageList>({
    includeExpired: false,
    includeInactive: false,
    includePreBookOnly: false,
    filter: "",
    booking: props.booking
  });
  const [filter, setFilter] = useState("");
  const [cancel, setCancel] = useState<NodeJS.Timeout | null>(null);
  const [selectedPackage, setSelectedPackage] = useState<Package>();
  const { t } = useTranslation();

  useEffect(() => {
    if (props.show == true) {
      setFilter("");
      setPackageListFetchParams({
        includeExpired: false,
        includeInactive: false,
        includePreBookOnly: false,
        filter: "",
        booking: props.booking,
      });
    }
  }, [props.show]);


  return <Dialog open={props.show}>
    <DialogTitle>
      {props.title == null ? (<Fragment>{t("pickers.selectPackage")}</Fragment>) : (<Fragment>{props.title}</Fragment>)}
    </DialogTitle>
    <DialogContent style={{ height: 40, minHeight: 40 }}>
      <TextInputField maxWidth={500} label={t("packages.searchPackages")} value={filter} onChange={(value) => {
        setFilter(value);
        if (cancel != null) {
          clearTimeout(cancel);
        }
        setCancel(setTimeout(() => {
          setPackageListFetchParams({
            ...packageListFetchParams,
            filter: value
          });
        }, 1000));
      }}></TextInputField>
    </DialogContent>
    <DialogContent>
      <div style={{ minHeight: 400, minWidth: 400 }}>
        <PagedDataView<IPackageList, Package>
          apiHook={api.hooks.packages.list}
          parameters={packageListFetchParams}
          renderItem={(item) => {

            if (item.code == props.currentPackageCode) {
              return <Fragment></Fragment>
            }
            return <PackageListItemSelector selected={selectedPackage == null ? false : item.id == selectedPackage.id} package={item} onSelectPackage={(pkg) => {
              setSelectedPackage(pkg);
              //setShowCreatePackage(true);
            }}></PackageListItemSelector>
          }}
        >
          <div style={{ padding: 20, backgroundColor: "#eee" }}>
            {t("packages.noPackages")}
          </div>
        </PagedDataView>
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => {
        props.onClose(null);
      }} data-testid="package-picker-cancel-button">{t("general.cancel")}</Button>
      <Button disabled={selectedPackage == null} onClick={() => {
        if (selectedPackage != null) {
          props.onClose(selectedPackage);
        }
      }} data-testid="package-picker-confirm-button"><b>{t("general.confirm")}</b></Button>
    </DialogActions>
  </Dialog>
}

PackagePicker.propTypes = {
  title: propTypes.string,
  currentPackageCode: propTypes.string,
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
}

export default PackagePicker;
